/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppLanguageDto } from '../models';
// @ts-ignore
import type { DictionaryItemDto } from '../models';
// @ts-ignore
import type { DictionaryTypeDto } from '../models';
/**
 * RestDictionariesApi - axios parameter creator
 * @export
 */
export const RestDictionariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all dictionaries or filter by type
         * @summary get dictionaries
         * @param {DictionaryTypeDto} [type] Dictionary type filter (optional)
         * @param {AppLanguageDto} [language] Language for dictionary labels (defaults to the request Accept-Language, POLISH when missing)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries: async (type?: DictionaryTypeDto, language?: AppLanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDictionariesApi - functional programming interface
 * @export
 */
export const RestDictionariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDictionariesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all dictionaries or filter by type
         * @summary get dictionaries
         * @param {DictionaryTypeDto} [type] Dictionary type filter (optional)
         * @param {AppLanguageDto} [language] Language for dictionary labels (defaults to the request Accept-Language, POLISH when missing)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaries(type?: DictionaryTypeDto, language?: AppLanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DictionaryItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaries(type, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDictionariesApi.getDictionaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDictionariesApi - factory interface
 * @export
 */
export const RestDictionariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDictionariesApiFp(configuration)
    return {
        /**
         * Get all dictionaries or filter by type
         * @summary get dictionaries
         * @param {DictionaryTypeDto} [type] Dictionary type filter (optional)
         * @param {AppLanguageDto} [language] Language for dictionary labels (defaults to the request Accept-Language, POLISH when missing)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaries(type?: DictionaryTypeDto, language?: AppLanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryItemDto>> {
            return localVarFp.getDictionaries(type, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDictionariesApi - interface
 * @export
 * @interface RestDictionariesApi
 */
export interface RestDictionariesApiInterface {
    /**
     * Get all dictionaries or filter by type
     * @summary get dictionaries
     * @param {DictionaryTypeDto} [type] Dictionary type filter (optional)
     * @param {AppLanguageDto} [language] Language for dictionary labels (defaults to the request Accept-Language, POLISH when missing)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestDictionariesApiInterface
     */
    getDictionaries(type?: DictionaryTypeDto, language?: AppLanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<DictionaryItemDto>>;

}

/**
 * RestDictionariesApi - object-oriented interface
 * @export
 * @class RestDictionariesApi
 * @extends {BaseAPI}
 */
export class RestDictionariesApi extends BaseAPI implements RestDictionariesApiInterface {
    /**
     * Get all dictionaries or filter by type
     * @summary get dictionaries
     * @param {DictionaryTypeDto} [type] Dictionary type filter (optional)
     * @param {AppLanguageDto} [language] Language for dictionary labels (defaults to the request Accept-Language, POLISH when missing)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestDictionariesApi
     */
    public getDictionaries(type?: DictionaryTypeDto, language?: AppLanguageDto, options?: RawAxiosRequestConfig) {
        return RestDictionariesApiFp(this.configuration).getDictionaries(type, language, options).then((request) => request(this.axios, this.basePath));
    }
}

